import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';

import { Link } from 'react-router-dom';
import { ButtonLink } from '../ButtonLink/ButtonLink';

interface LinkConfirmDialogProps {
    to: string;
    text: string;
    open: boolean;
    onClose: () => void;
    translations: Record<string, string>;
}

export const LinkConfirmDialog: React.FC<LinkConfirmDialogProps> = ({ to, text, open, onClose, translations }) => (
    <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle>{translations.EXTERNAL_LINK_CONFIRM_TITLE}</DialogTitle>
        <DialogContent>{text}</DialogContent>
        <DialogActions>
            <Button onClick={onClose} color="primary" size="large">
                {translations.GLOBAL_CANCEL_BUTTON}
            </Button>
            {to.includes('http') && (
                <Button
                    component={Link}
                    to={to}
                    target="_blank"
                    rel="noreferrer noopener"
                    color="primary"
                    size="large"
                    variant="contained"
                    onClick={onClose}
                    sx={{ textDecoration: 'none' }}
                >
                    {translations.GLOBAL_CONFIRM_BUTTON}
                </Button>
            )}
            {!to.includes('http') && <ButtonLink fullWidth={false} to={to} text={translations.GLOBAL_CONFIRM_BUTTON} />}
        </DialogActions>
    </Dialog>
);
